var _excluded = ["onMount", "onItemUnmount", "readyToStart", "readyToRender"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import VirtualScrollerCore from '../VirtualScroller.js';
import log, { warn } from '../utility/debug.js';
import px from '../utility/px.js';

var VirtualScroller = /*#__PURE__*/function () {
  function VirtualScroller(_itemsContainerElement, _items, renderItem) {
    var _this = this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, VirtualScroller);

    _defineProperty(this, "render", function (state, prevState) {
      var items = state.items,
          firstShownItemIndex = state.firstShownItemIndex,
          lastShownItemIndex = state.lastShownItemIndex,
          beforeItemsHeight = state.beforeItemsHeight,
          afterItemsHeight = state.afterItemsHeight;

      var itemsContainerElement = _this.getItemsContainerElement(); // log('~ On state change ~')
      // log('Previous state', prevState)
      // log('New state', state)
      // Set items container's padding-top and padding-bottom.
      // But only do that for a non-`<tbody/>` item container
      // because, strangely, CSS `padding` doesn't work on a `<tbody/>` element.
      // https://gitlab.com/catamphetamine/virtual-scroller/-/issues/1
      //
      // `this.virtualScroller` hasn't been initialized yet at this stage,
      // so this code can't use `this.virtualScroller.isItemsContainerElementTableBody()` function yet.
      // Instead, it uses its own method of detecting the use of a `<tbody/>` container.
      //


      if (!_this.virtualScroller.isItemsContainerElementTableBody()) {
        itemsContainerElement.style.paddingTop = px(beforeItemsHeight);
        itemsContainerElement.style.paddingBottom = px(afterItemsHeight);
      } // Perform an intelligent "diff" re-render if the `items` are the same.


      var diffRender = prevState && items === prevState.items && items.length > 0; // Remove no longer visible items from the DOM.

      if (diffRender) {
        // Decrement instead of increment here because
        // `itemsContainerElement.removeChild()` changes indexes.
        var _i = prevState.lastShownItemIndex;

        while (_i >= prevState.firstShownItemIndex) {
          if (_i >= firstShownItemIndex && _i <= lastShownItemIndex) {// The item is still visible.
          } else {
            log('DOM: Remove element for item index', _i); // The item is no longer visible. Remove it.

            _this.unmountItem(itemsContainerElement.childNodes[_i - prevState.firstShownItemIndex]);
          }

          _i--;
        }
      } else {
        log('DOM: Rerender the list from scratch');

        while (itemsContainerElement.firstChild) {
          _this.unmountItem(itemsContainerElement.firstChild);
        }
      } // Add newly visible items to the DOM.


      var shouldPrependItems = diffRender;
      var prependBeforeItemElement = shouldPrependItems && itemsContainerElement.firstChild;
      var i = firstShownItemIndex;

      while (i <= lastShownItemIndex) {
        if (diffRender && i >= prevState.firstShownItemIndex && i <= prevState.lastShownItemIndex) {
          // The item is already being rendered.
          // Next items will be appended rather than prepended.
          if (shouldPrependItems) {
            shouldPrependItems = false;
          }
        } else {
          var item = _this.renderItem(items[i]);

          if (shouldPrependItems) {
            log('DOM: Prepend element for item index', i); // Append `item` to `itemsContainerElement` before the retained items.

            itemsContainerElement.insertBefore(item, prependBeforeItemElement);
          } else {
            log('DOM: Append element for item index', i); // Append `item` to `itemsContainerElement`.

            itemsContainerElement.appendChild(item);
          }
        }

        i++;
      } // Call `onMount()` function when the list has rendered for the first time.
      //
      // `onMount()` option is deprecated due to no longer being used.
      // If someone thinks there's a valid use case for it, create an issue.
      //


      if (!_this._isMounted) {
        _this._isMounted = true;

        if (_this._onMount) {
          _this._onMount();
        }
      }
    });

    _defineProperty(this, "onUnmount", function () {
      warn('`.onUnmount()` instance method name is deprecated, use `.stop()` instance method name instead.');

      _this.stop();
    });

    _defineProperty(this, "destroy", function () {
      warn('`.destroy()` instance method name is deprecated, use `.stop()` instance method name instead.');

      _this.stop();
    });

    _defineProperty(this, "stop", function () {
      _this.virtualScroller.stop();
    });

    _defineProperty(this, "start", function () {
      _this.virtualScroller.start();
    });

    this.getItemsContainerElement = typeof _itemsContainerElement === 'function' ? _itemsContainerElement : function () {
      return _itemsContainerElement;
    };
    this.renderItem = renderItem;

    var onMount = options.onMount,
        onItemUnmount = options.onItemUnmount,
        readyToStart = options.readyToStart,
        readyToRender = options.readyToRender,
        restOptions = _objectWithoutProperties(options, _excluded); // `onMount()` option is deprecated due to no longer being used.
    // If someone thinks there's a valid use case for it, create an issue.


    this._onMount = onMount;
    this.onItemUnmount = onItemUnmount;
    this.virtualScroller = new VirtualScrollerCore(this.getItemsContainerElement, _items, _objectSpread(_objectSpread({}, restOptions), {}, {
      render: this.render
    }));

    if (readyToRender === false) {// Don't automatically perform the initial render of the list.
      // This means that neither `this.render()` nor `this.start()` methods should be called.
    } else if (readyToStart === false) {
      // Don't automatically call the `.start()` method of the "core" component.
      // Still, perform the initial render of the list.
      this.render(this.virtualScroller.getInitialState());
    } else {
      // Calls the `.start()` method of the "core" component.
      // It performs the initial render of the list and starts listening to scroll events.
      this.start();
    }
  }

  _createClass(VirtualScroller, [{
    key: "unmountItem",
    value: function unmountItem(itemElement) {
      this.getItemsContainerElement().removeChild(itemElement);

      if (this.onItemUnmount) {
        this.onItemUnmount(itemElement);
      }
    }
    /**
     * @deprecated
     * `.onItemHeightChange()` has been renamed to `.onItemHeightDidChange()`.
     */

  }, {
    key: "onItemHeightChange",
    value: function onItemHeightChange(i) {
      warn('`.onItemHeightChange(i)` method was renamed to `.onItemHeightDidChange(i)`');
      this.onItemHeightDidChange(i);
    }
  }, {
    key: "onItemHeightDidChange",
    value: function onItemHeightDidChange(i) {
      this.virtualScroller.onItemHeightDidChange(i);
    }
  }, {
    key: "setItemState",
    value: function setItemState(i, newState) {
      this.virtualScroller.setItemState(i, newState);
    }
    /**
     * @deprecated
     * `.updateItems()` has been renamed to `.setItems()`.
     */

  }, {
    key: "updateItems",
    value: function updateItems(newItems, options) {
      warn('`.updateItems()` method was renamed to `.setItems(i)`');
      this.setItems(newItems, options);
    }
  }, {
    key: "setItems",
    value: function setItems(newItems, options) {
      this.virtualScroller.setItems(newItems, options);
    }
    /*
    getItemCoordinates(i) {
      return this.virtualScroller.getItemCoordinates(i)
    }
    */

  }]);

  return VirtualScroller;
}();

export { VirtualScroller as default };
//# sourceMappingURL=VirtualScroller.js.map